package com.dwarshb.bms

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class DatabaseQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAllUsers(mapper: (
    idToken: String,
    email: String,
    refreshToken: String?,
    name: String?,
    localId: String?,
    phone: String?,
  ) -> T): Query<T> = Query(-8_843_344, arrayOf("User"), driver, "Database.sq", "selectAllUsers",
      """
  |SELECT User.idToken, User.email, User.refreshToken, User.name, User.localId, User.phone
  |FROM User
  """.trimMargin()) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5)
    )
  }

  public fun selectAllUsers(): Query<User> = selectAllUsers { idToken, email, refreshToken, name,
      localId, phone ->
    User(
      idToken,
      email,
      refreshToken,
      name,
      localId,
      phone
    )
  }

  public fun <T : Any> selectUserByEmail(email: String, mapper: (
    idToken: String,
    email: String,
    refreshToken: String?,
    name: String?,
    localId: String?,
    phone: String?,
  ) -> T): Query<T> = SelectUserByEmailQuery(email) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5)
    )
  }

  public fun selectUserByEmail(email: String): Query<User> = selectUserByEmail(email) { idToken,
      email_, refreshToken, name, localId, phone ->
    User(
      idToken,
      email_,
      refreshToken,
      name,
      localId,
      phone
    )
  }

  /**
   * @return The number of rows updated.
   */
  public fun insertUser(
    idToken: String,
    email: String,
    refreshToken: String?,
    name: String?,
    localId: String?,
    phone: String?,
  ): QueryResult<Long> {
    val result = driver.execute(314_125_905, """
        |INSERT INTO User(idToken,email,refreshToken,name,localId,phone)
        |VALUES(?, ?, ?, ?,?,?)
        """.trimMargin(), 6) {
          bindString(0, idToken)
          bindString(1, email)
          bindString(2, refreshToken)
          bindString(3, name)
          bindString(4, localId)
          bindString(5, phone)
        }
    notifyQueries(314_125_905) { emit ->
      emit("User")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun removeAllUsers(): QueryResult<Long> {
    val result = driver.execute(1_739_377_464, """DELETE FROM User""", 0)
    notifyQueries(1_739_377_464) { emit ->
      emit("User")
    }
    return result
  }

  private inner class SelectUserByEmailQuery<out T : Any>(
    public val email: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("User", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("User", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_356_865_583, """
    |SELECT User.idToken, User.email, User.refreshToken, User.name, User.localId, User.phone
    |FROM User WHERE email = ?
    """.trimMargin(), mapper, 1) {
      bindString(0, email)
    }

    override fun toString(): String = "Database.sq:selectUserByEmail"
  }
}
